import React, { Component } from "react";
import { FormGroup, InputGroup, FormControl, OverlayTrigger, Popover } from 'react-bootstrap'
import { Link } from "react-router-dom"
import { connect } from 'react-redux'
import {
    fetchCartProducts, fetchExtraCartProducts, changeSearchLabel, setLoadingSearchPage,
    setProductsReducer, fetchProducts, fetchSearchInput, clearOverlay
} from '../actions'
import { cuttingLongNameText } from '../utils'
import _ from 'lodash'
class NavHeader extends Component {

    state = {
        showMenu: false,
        showMenuText: false,
        islogin: localStorage.getItem('user') == null ? false : true,
        searchinput: '',
        count: 1,
        popover: { product_name: 'name', product_amount: '1', product_unit: 'kg' },
        cartshaked: false,
    }

    componentWillMount() {
        this.props.fetchCartProducts()
        this.props.fetchExtraCartProducts()
        if (this.props.id != undefined) {
            this.props.setLoadingSearchPage(true)
            this.props.changeSearchLabel(this.props.id)
            this.setState({ searchinput: this.props.id })
            this.props.fetchProducts(this.props.id)
            this.props.fetchSearchInput(this.props.id)
        }
    }

    componentWillReceiveProps(nextProps) {
        // console.log('np', nextProps)
        if (JSON.stringify(this.props.cart_products) == JSON.stringify(nextProps.cart_products) &&
            JSON.stringify(this.props.cart_extraproducts) == JSON.stringify(nextProps.cart_extraproducts) &&
            JSON.stringify(this.props.overlay_trigger) == JSON.stringify(nextProps.overlay_trigger)
        ) {
            if (nextProps.searchinput != this.state.searchinput && nextProps.products == this.props.products) {
                // console.log('click category')
                this.setState({ searchinput: nextProps.searchinput })
                this.props.setLoadingSearchPage(true)
                this.props.fetchProducts(nextProps.searchinput)
                this.props.changeSearchLabel(nextProps.searchinput)
            }
            if (this.props.id != nextProps.id && this.props.searchinput == nextProps.searchinput && nextProps.id) {
                // console.log('click back forward')
                this.setState({ searchinput: nextProps.id })
                this.props.setLoadingSearchPage(true)
                this.props.fetchProducts(nextProps.id)
                this.props.changeSearchLabel(nextProps.id)
            }
        }
        if (JSON.stringify(nextProps.overlay_trigger) != JSON.stringify(this.props.overlay_trigger) && nextProps.overlay_trigger != '') {
            this.setState({ popover: { ...nextProps.overlay_trigger } })
            this.showAlert()
        }
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside.bind(this));
    }

    componentWillUnmount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        clearInterval(this.timer)
    }

    getTotalProduct() {
        let totalproduct = 0
        _.map(this.props.cart_products, product => {
            totalproduct += 1
        })
        return totalproduct
    }
    getTotalExtraProduct() {
        let totalproduct = 0
        _.map(this.props.cart_extraproducts, product => {
            totalproduct += 1
        })
        return totalproduct
    }

    handleClickOutside(event) {
        if (this.navMenu && !this.navMenu.contains(event.target) && this.state.showMenu) {
            this.setState({ showMenu: false, showMenuText: false })
        }
    }

    onLoginClicked() {
        this.props.history.push('/login')
    }

    onLogOut() {
        // window.Intercom('shutdown')
        // window.Intercom('boot', {
        //     app_id: 'j77n0bkz',
        // });
        localStorage.removeItem('user')
        this.props.history.push('/login')
    }

    startTimer() {
        this.setState({ count: 1 })
        clearInterval(this.timer)
        this.timer = setInterval(this.tick.bind(this), 1000)
    }

    tick() {
        this.setState({ count: (this.state.count - 1) })
        this.state.count == 0 ? this.timeout() : ''
    }

    timeout() {
        clearInterval(this.timer)
        this.setState({ count: 1 })
        this.props.fetchSearchInput(this.state.searchinput)
        if (this.state.searchinput) {
            this.props.history.push('/search/' + this.state.searchinput)
            this.props.fetchProducts(this.state.searchinput)
        } else {
            this.props.history.push('/')
        }
    }

    render() {
        const user = (JSON.parse(localStorage.getItem('user')) || undefined)
        const popoverBottom = (
            <Popover className='hidden-sm hidden-md hidden-lg' style={{ zIndex: 2100 }} id="popover-positioned-bottom">
                คุณได้เพิ่ม <strong>{this.state.popover.product_name}</strong> <br />
                จำนวน <strong>{this.state.popover.product_amount} {this.state.popover.product_unit}</strong>
            </Popover>
        )
        return (
            <div style={{ width: '100%', height: "auto", backgroundColor: 'black', position: 'fixed', top: 0, zIndex: 2000 }}>
                <div style={{ color: 'white', display: 'flex' }}>
                    <div style={{ display: 'inline-block', padding: 10, cursor: 'pointer' }}
                        onClick={() => {
                            this.setState({ showMenu: true })
                            setTimeout(() => { this.setState({ showMenuText: true }) }, 500)
                        }}
                    >
                        <div style={{ fontSize: 20, marginTop: 7, marginLeft: 2 }} className='fa fa-bars'>
                            <div style={{ display: 'inline-block', paddingLeft: 5, fontFamily: 'kanit', fontSize: 14 }}></div>
                        </div>
                    </div>
                    <div style={{ width: '80%', display: 'inline-block', padding: 6, height: 40 }}>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <img style={{ width: 85, cursor: 'pointer' }}
                                onClick={() => { this.props.history.push('/'); this.setState({ showMenu: false, showMenuText: false }) }}
                                src='../../static/images/logo_black_white.png' />
                        </div>
                    </div>
                    {/* <div >
                        <a href="/login" >
                            <img src="../../static/images/logo_login.png" style={{ float: "right" }} />
                        </a>
                    </div> */}
                </div>

                {/* menu */}
                <div className="sidenav" ref={(e) => { this.navMenu = e }} style={{ width: this.state.showMenu ? 240 : 0, backgroundColor: 'black' }}>
                    <div className='fadeIn' style={{ display: this.state.showMenuText ? '' : 'none' }}>
                        <div style={{ padding: '20px 15px 20px 15px', color: 'white' }}>
                            <img onClick={() => { this.props.history.push('/'); this.setState({ showMenu: false, showMenuText: false }) }}
                                style={{ width: 75, cursor: 'pointer' }}
                                src='../../static/images/logo_black_white.png' />
                            <span style={{ float: 'right', fontSize: 35, cursor: 'pointer' }}
                                onClick={() => { this.setState({ showMenu: false, showMenuText: false }) }}>
                                &times;</span>
                        </div>

                        <a onClick={() => { this.props.history.push('/#service'); this.setState({ showMenu: false, showMenuText: false }) }}><div style={{ width: 30, fontSize: 17, marginLeft: -3, marginRight: 3 }}></div><div className='sidenav-main-item'>{'บริการสินค้าราคาส่ง'}</div></a>
                        <a onClick={() => { this.props.history.push('/#guarantee'); this.setState({ showMenu: false, showMenuText: false }) }}><div style={{ width: 30, fontSize: 17 }}></div><div className='sidenav-main-item'>{'การรับประกันคุณภาพ'}</div></a>
                        <a onClick={() => { this.props.history.push('/#transport'); this.setState({ showMenu: false, showMenuText: false }) }}><div style={{ width: 30, fontSize: 17 }} ></div><div className='sidenav-main-item'>{'บริการขนส่ง'}</div></a>
                        <a onClick={() => { this.props.history.push('/#payment'); this.setState({ showMenu: false, showMenuText: false }) }}><div style={{ width: 30, fontSize: 17 }} ></div><div className='sidenav-main-item'>{'ช่องทางการชำระเงิน'}</div></a>
                        {/* <a onClick={() => { this.props.history.push('/blog/all'); this.setState({ showMenu: false, showMenuText: false }) }}><div style={{ width: 30, fontSize: 17 }} ></div><div className='sidenav-main-item'>{'เงื่อนไขการให้บริการ'}</div></a> */}
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        cart_products: state.cart_products_reducer,
        cart_extraproducts: state.cart_extraproducts_reducer,
        searchinput: state.searchinput,
        products: state.products,
        overlay_trigger: state.overlay_trigger_reducer,
    };
}

export default connect(mapStateToProps, {
    fetchCartProducts, fetchExtraCartProducts, changeSearchLabel,
    setLoadingSearchPage, setProductsReducer, fetchProducts, fetchSearchInput, clearOverlay
})(NavHeader)


// WEBPACK FOOTER //
// ./src/components/navBarMobileBusiness.js